import { mix } from "@chorda/core";
export const List = (props) => {
    return mix({
        tag: 'ul',
        defaultItem: {
            tag: 'li'
        },
        reactions: {
            items: (v) => ({ items: v })
        },
    }, props && {
        items: props.items,
        defaultItem: props.defaultItem,
        injections: {
            items: props.items$
        },
    });
};
export const ListItem = (props) => {
    return mix({
        reactions: {
            text: (v) => ({ text: v })
        }
    }, props.as, props && {
        css: props.css,
        text: props.text,
        injections: {
            text: props.text$
        }
    });
};
